import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function SavedSearchPreview({ filters = {}, title }) {
  const { t } = useTranslation();

  const i18n = useMemo(() => ({
    client: t('Client'),
    shopcity: t('City'),
    username: t('Team'),
    shopcountry: t('Country'),
    sector: t('Sector'),
    shopname: t('Shop name'),
    shopprovince: t('Province'),
    shopsign: t('Shop sign'),
    project: t('Program'),
    shopzipcode: t('Zip code'),
    item: t('Item'),
    translatedquestion: t('Question'),
    createdat: t('Period'),
  }), [t]);
  const getFilterSummary = () => {
    // S'assurer que filters est un objet non-null
    const safeFilters = filters || {};

    return Object.entries(safeFilters)
      .filter(([key, value]) => {
        // Ignore empty values and createdat
        if (!value || key === 'createdat') return false;
        return true;
      })
      .map(([key, value]) => {
        // Handle different value types
        let displayValue = '';
        if (Array.isArray(value)) {
          displayValue = value.map(v => v.label).join(', ');
        } else if (typeof value === 'object') {
          displayValue = value.label;
        } else {
          displayValue = value.toString();
        }

        return {
          label: i18n[key] || key,
          value: displayValue
        };
      });
  };

  const filterSummary = getFilterSummary();

  if (filterSummary.length === 0) return null;

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-md">
      <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {title || t('Current filters')}
      </h4>
      <div className="space-y-2">
        {filterSummary.map(({ label, value }) => (
          <div key={label} className="flex text-sm">
            <span className="font-medium text-gray-500 dark:text-gray-400 w-1/3">
              {label}:
            </span>
            <span className="text-gray-900 dark:text-gray-100 w-2/3">
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}